import './sass/theme.scss';
import './js/scripts.js';
// import './images/bg.gif';
